import { createFileRoute } from '@tanstack/react-router'

import { ReceiveQuotePage } from '../../../../components/pages/receive-quote-page.tsx'

export const Route = createFileRoute('/s/q/$token')({
  component: () => <ReceiveQuotePage version={3} />,
})
